import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginD, sendOtp } from '../store/authSlice';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout/Layout';

function Home() {

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { isAuthenticated, mobileNumber } = useSelector((state) => state.auth)
    const [mobile, setMobile] = useState(null)
    const [isError, setIsError] = useState(false)
    const loginAction = async () => {
        if(mobile) {
            await dispatch(sendOtp({mobileNumber: mobile}))
        } else {
            setIsError(true)
        }
    }
    useEffect(() => {
        if(mobileNumber) {
            navigate('/otp')
        }
    }, [mobileNumber])
    useEffect(() => {
        if(isAuthenticated) {
            navigate('/')
        }
    }, [isAuthenticated])
  return (
    <Layout>
        <section className='section login-form' style={{}}>
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Login</h5>
                    <div className="col-md-12 pd5">
                        <div className="form-floating">
                            <input type="test" className="form-control" id="floatingEmail" placeholder="Mobile Number" onChange={(e) => {
                                setMobile(e.target.value); 
                                e.target.value ? setIsError(false) : setIsError(true);
                                }}
                            />
                            <label htmlFor="floatingEmail">Mobile</label>
                            {isError ? <span className='error'>Please Enter Mobile Number</span> : null}
                        </div>
                    </div>
                    
                    <div className="text-center pd5">
                        <button onClick={() => loginAction()} className="btn btn-primary">Get OTP</button>
                    </div>
                </div>
            </div>
        </section>
        
    </Layout>
    
  );
}

export default Home;
